import type React from 'react';
import Modal from 'react-modal';

import { useClients } from '@entities/clients';

import { ModalLarge } from '@src/library/components/common';

Modal.setAppElement('#root');

interface Props {
	children?: React.ReactNode;
}

export const ClientModal: React.FC<Props> = ({ children }) => {
	const { selectedClient: selected, select } = useClients();

	const onClose = () => select();

	return (
		<ModalLarge title="Клиент" isOpen={!!selected} onRequestClose={onClose} close={onClose}>
			{children}
		</ModalLarge>
	);
};
